export default __webpack_public_path__ + "static/media/DocInfoFill.dd04e3ca.svg";